import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';

import { PartialDataAdd } from '../../caching/partial-data-store';
import AboveTheFoldOnlyServerRender from '../../shared/components/above-the-fold-only-server-render';
import UDFContent from './udf-content';

import '../../gift-guide/css/gift-guide-product-map.less';

const productMapWithSingleContainer = (elem) => (
    <div className="column-container">
        {elem}
    </div>
);

const productMap = props => {
    const {
        products,
        productItem,
        enableAppPDP,
        productItemClassName = 'product-card',
        customPlaceHolder,
        lazyLoadPlaceHolderHeight = 750,
        v2,
        leftMenuActive,
        disableMultiContainers
    } = props;

    const listLength = products.length;
    const menuActive = useRef(leftMenuActive);
    
    const getCols = (width, menu) => {
        switch (true) {
            case width >= 1920:
                return menu ? 3 : 4;
            case width >= 1024 && width <= 1919:
                return menu ? 2 : 3;
            case width >= 768 && width <= 1023:
                return 2;
            default:
                return 1;
        }
    };

    const [colSpan, setColSpan] = useState(4);

    const onResize = () => {
        const clientWidth = window.innerWidth;
        setColSpan(getCols(clientWidth, menuActive.current));
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setColSpan(getCols(window.innerWidth, leftMenuActive));
        }
        menuActive.current = leftMenuActive;
    }, [leftMenuActive]);

    useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const wrapRow = (elems, cols) => {
        if (!v2) {
            return disableMultiContainers 
                    ? productMapWithSingleContainer(elems)
                    : elems;
        }

        if(disableMultiContainers){
            return productMapWithSingleContainer(elems);
        }

        const rowElems = [];
        const rowCount = Math.ceil(elems.length / cols);
        for (let index = 0; index < rowCount; index++) {
            rowElems.push(<div className="column-container">{elems.slice(index * cols, index * cols + cols)}</div>);
        }
        return rowElems;
    };

    return (
        <div>
            {wrapRow(
                products.map((product, i) => {
                    let isLast = listLength - 1 === i;
                    let className = ` ${isLast ? 'last' : ''} position-${i}`;
                    const isUDF = product.prdClass === 'USER_DEFINED';
                    let prdContent = !isUDF ? (
                        <PartialDataAdd
                            cacheKey={product.slug || product.linkUrl}
                            cacheValue={product}
                            schema="product"
                        >
                            {productItem(product, i, enableAppPDP, className, i)}
                        </PartialDataAdd>
                    ) : (
                        <UDFContent
                            className={`${className}${productItemClassName ? ' ' + productItemClassName : ''}`}
                            html={product.metadata && product.metadata.html}
                        />
                    );
                    //lazy placeHolder
                    let placeHolderProps;
                    if (customPlaceHolder) {
                        placeHolderProps = {
                            placeholder: productItem(product, i, enableAppPDP, className, i, true),
                        };
                    } else {
                        placeHolderProps = {
                            placeholderStyle: { height: lazyLoadPlaceHolderHeight },
                            placeholderClassName: `lazyload ${productItemClassName}`,
                        };
                    }
                    return (
                        <AboveTheFoldOnlyServerRender
                            key={isUDF ? `UDF-${i}` : `${product.sku}-${i}`}
                            skipEval={(deviceType, pageOptimization = {}) => {
                                const { mobileMaxProducts, tabletMaxProducts, desktopMaxProducts } = pageOptimization;
                                const maxProducts =
                                    deviceType === 'mobile'
                                        ? mobileMaxProducts || 1
                                        : deviceType === 'tablet'
                                        ? tabletMaxProducts || 3
                                        : desktopMaxProducts || 5;

                                if (maxProducts) {
                                    //if defined, skip all products passed max
                                    return i + 1 > maxProducts;
                                } else if (isUDF && i === product.length - 1) {
                                    //always skip UDF footer banner
                                    return true;
                                } else {
                                    return false;
                                }
                            }}
                            offset={300}
                            {...placeHolderProps}
                        >
                            {prdContent}
                        </AboveTheFoldOnlyServerRender>
                    );
                }),
                colSpan
            )}
        </div>
    );
};

const mapStateToProps = state => {
    const { leftMenu } = state;
    return {
        leftMenuActive: leftMenu.active,
    };
};

export default connect(mapStateToProps, undefined)(productMap);
